module.exports = __webpack_public_path__ + "static/23-c7c1884ba11a795ab581a0715342e8e5.jpg";